export default __webpack_public_path__ + "static/media/WAS0390.34I-39722_-23582_0.e7a63368.jpg";